module.exports = __webpack_public_path__ + "img/mead.b9859aa1.png";